import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getDispensaAll, setBloqueaDispensa, setDesvinculaDispensa } from "../../services/dispensador";
import Icon from "../../Icons/general/Icon";
import IconM from "../dashboard/menu/icons/Icon";
import DispensaModal from "./dispensamodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";


function ExpendedorView() 
{
  const [Area, setArea] = useState([]);
  const [DispArea, setDispArea] = useState([]);
  const [Dispensa, setDispensa] = useState([]);

  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState([]);
  const [DispensaId, setDispensaId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(Dispensa, page, 10);
  const nombreAreaPorDisp = {};  
  
  //----- Metodo para mostrar las areas en la grilla
   
  const fillDispensa = async () => 
    {
       setShowToast(false);
    
       const response = await getDispensaAll();
       if (response) 
        {
          if (response.status === 200) 
            {
               setDispensa(response.data.data);
               setArea(response.data.area);
               setDispArea(response.data.areadisp);
            } 
          else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
    };

  // boton crear-Editar-Eliminar Area
  const handleCrearService = (tagId) => 
    {
       if ((selectedRow === null) && (tagId !== 0)) return
      
       if (tagId === 0) 
        {
          setAreaId([]);
          setDispensaId(0);
        }
       setShowM(true);
       setTag(tagId);
    };

  // Bloquea- Desbloquea
  const handleBloqueaService = async (tagId) => 
    {
       setShowToast(false);
       if ((selectedRow === null) ) return
         const response = await setBloqueaDispensa(AreaId, DispensaId, tagId);
       if (response) 
         {
           if (response.status === 200) 
            {
              setTag(0);
              setEstado(response.data.data[0].Estado);
              setAreaId(response.data.data[0].AreaId);
              fillDispensa();
            } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }
        else 
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
         }
    };
  
  //------  Desvinculra Equipo
  const handleDesvincular = async () => 
    {
       setShowToast(false);
       const response = await setDesvinculaDispensa(AreaId, DispensaId);
       if (response) 
         {
           if (response.status === 200) 
            {
              setAreaId(response.data.data[0].AreaId);
              fillDispensa();
            } 
           else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
         }
       else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }   
    }
  
//----- al dar click en la fila ----------------------------------------------------------------------------------------
 const handlefilas = (Item, index) => 
  {
    setSelectedRow(index);
    setDispensaId(Item.DispensaId);
    const areasSeleccionadas = DispArea.filter(itemI => itemI.DispensaId === Item.DispensaId)
                                       .map(itemI => itemI.AreaId);
    
    setAreaId(areasSeleccionadas);                                   
    setEstado(Item.Estado);
  };

//----------------------------------------------------------------------------------------------------------------------  
  DispArea.forEach(({ DispensaId, NombreArea }) => 
   {
     if (!nombreAreaPorDisp[DispensaId]) 
       nombreAreaPorDisp[DispensaId] = [];
     nombreAreaPorDisp[DispensaId].push(NombreArea);
   });

  Object.keys(nombreAreaPorDisp).forEach(id => 
  {
    nombreAreaPorDisp[id] = nombreAreaPorDisp[id].join(', ');
  });
//------ Inicio
  useEffect(() => {
    setShowM(false);
    fillDispensa();
  }, []);
  
  return (
    <>
      <div className="">
        <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Dispensador</label>
        </div>
      
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearService(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearService(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearService(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}

            <button className="btnmenu"  id="Desvincular" disabled={selectedRow === null} onClick={handleDesvincular}>
              <IconM svg="link" className="iconmenu" title="link"/>
              <span>Desvincular</span>
            </button>
  
          </div>
          <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="w-full table-auto">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Tipo Dispensación</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                   <th className="px-2.5 py-2 text-start font-medium">Codigo Vinc.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Key Vinc.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Imprime</th>
                   <th className="px-2.5 py-2 text-start font-medium">Impresora</th>
                   <th className="px-2.5 py-2 text-start font-medium">Lector</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                           <td>{item.DispensaId}</td>
                           <td>{item.TipoDispensa ==="M" ? "Múltiples areas":"Una sola área" }</td>
                           <td>{item.NombreDisp}</td>
                           <td>{nombreAreaPorDisp[item.DispensaId] || 'Sin áreas'}</td>
                           <td>{item.CodigoVinc}</td>
                           <td>{item.ClientAPKey}</td>
                           <td className="item-center justify-center text-center px-8">
                             {item.Imprime === "SI" ? (<Icon svg="checkSquare" className="w-[1.2rem] h-[1.2rem]" title="checklg"/>
                                                      ) : ("")
                             }
                          </td>
                         <td>{item.Impresora}</td>
                         <td className="item-center justify-center text-center px-8">
                             {item.Lector === "SI" ? (<Icon svg="checkSquare" className="w-[1.2rem] h-[1.2rem]" title="checklg"/>
                                                      ) : ("")
                             }
                          </td>
                         <td className="center">
                              {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                         </td>
                      </tr>
                    )})}
               </tbody>
             </table>
             </div>
             <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
       </div>
      <DispensaModal
        show={showM}
        AreaI={AreaId}
        DispensaI={DispensaId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={fillDispensa}
      ></DispensaModal>
    </>
  );
}
export default ExpendedorView;
